import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Team } from './pages/Team';
import { Services } from './pages/Services';
import { Employers } from './pages/Employers';
import { Candidates } from './pages/Candidates';
import { LeadershipBoardSearch } from './pages/LeadershipBoardSearch';
import { Contact } from './pages/Contact';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfUse } from './pages/TermsOfUse';
import { NotFound } from './pages/NotFound';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2wk08wyxu0jug">
      <Routes data-id="element-1" data-mp="2wjgp1comflds">
        <Route element={<Layout data-id="element-3" data-mp="2wj8evsjvuu6a" />} data-id="element-2" data-mp="2wiyy8vkq9zd9">
          <Route index element={<Home data-id="element-5" data-mp="28ufqch5lbolp" />} data-id="element-4" data-mp="2whx9joashed2" />
          <Route path="about" element={<About data-id="element-7" data-mp="28t4kmbsl46ry" />} data-id="element-6" data-mp="28tw4ipctkg2e" />
          <Route path="our-team" element={<Team data-id="element-9" data-mp="23vkwmk634fmt" />} data-id="element-8" data-mp="28skzynbjv4a8" />
          <Route path="services" element={<Services data-id="element-11" data-mp="23utb6267bya9" />} data-id="element-10" data-mp="23w4g45bdvc2y" />
          <Route path="employers" element={<Employers data-id="element-13" data-mp="3ikhaeg9qb525" />} data-id="element-12" data-mp="23ti864kkyuk7" />
          <Route path="candidates" element={<Candidates data-id="element-15" data-mp="3ihv1ac76whht" />} data-id="element-14" data-mp="3ij63w8owfj7c" />
          <Route path="leadership-board-search" element={<LeadershipBoardSearch data-id="element-17" data-mp="3mjzrt22ccy08" />} data-id="element-16" data-mp="3mlax56bfqdtg" />
          <Route path="contact" element={<Contact data-id="element-19" data-mp="3rbzomln47asl" />} data-id="element-18" data-mp="3rc9e8848zfxr" />
          <Route path="privacy-policy" element={<PrivacyPolicy data-id="element-21" data-mp="3relwynhtxubv" />} data-id="element-20" data-mp="3rcsxpt9jqcdw" />
          <Route path="terms-of-use" element={<TermsOfUse data-id="element-23" data-mp="5ghbgghm2z1" />} data-id="element-22" data-mp="67z9oh5w26u" />
          <Route path="*" element={<NotFound data-id="element-25" data-mp="2zllf11m4wkmq" />} data-id="element-24" data-mp="7st1bvnjh3n" />
        </Route>
      </Routes>
    </BrowserRouter>;
}